var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "overlay-color": "grey darken-2",
        transition: "scroll-x-transition",
        "content-class": "ec-confirmation-dialog",
        width: "440",
      },
      on: { change: _vm.handleDialogChange },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { color: "accent", width: "440" } },
        [
          _c(
            "v-list",
            { attrs: { color: "accent" } },
            [
              _vm.noProfilesExist
                ? _c("p", { staticClass: "mb-3 pt-3 pl-4" }, [
                    _vm._v(" Create a new user profile "),
                  ])
                : _c("p", { staticClass: "mb-3 pt-3 pl-4" }, [
                    _vm._v("Select a user profile"),
                  ]),
              _c("v-divider"),
              _c(
                "div",
                {
                  staticStyle: { "max-height": "250px", "overflow-y": "auto" },
                },
                _vm._l(_vm.profiles, function (profile) {
                  return _c(
                    "v-list-item",
                    {
                      key: profile.id,
                      staticClass: "mb-0",
                      on: {
                        click: function ($event) {
                          return _vm.selectUserProfile(profile)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        { staticClass: "my-0" },
                        [
                          profile.configuration.device ==
                          _vm.profileDeviceTypes.Desktop
                            ? _c("v-icon", { attrs: { size: "22" } }, [
                                _vm._v("fas fa-desktop "),
                              ])
                            : profile.configuration.device ==
                              _vm.profileDeviceTypes.Laptop
                            ? _c("v-icon", { attrs: { size: "22" } }, [
                                _vm._v("fas fa-laptop "),
                              ])
                            : profile.configuration.device ==
                              _vm.profileDeviceTypes.Mobile
                            ? _c("v-icon", { attrs: { size: "22" } }, [
                                _vm._v("fas fa-mobile-alt "),
                              ])
                            : profile.configuration.device ==
                              _vm.profileDeviceTypes.Tablet
                            ? _c("v-icon", { attrs: { size: "22" } }, [
                                _vm._v("fas fa-tablet-alt "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(profile.configuration.device) + " "),
                            _vm.isAdmin
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mt-1 grey--text",
                                    staticStyle: {
                                      position: "absolute",
                                      top: "14px",
                                      left: "140px",
                                      "font-size": "12px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " (" + _vm._s(profile.username) + ") "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-action",
                        {
                          staticStyle: {
                            "margin-top": "6px",
                            "margin-bottom": "6px",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.deleteProfileConfirmation(profile)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "icon-delete-21x21",
                                  staticStyle: { "font-size": "28px" },
                                },
                                [
                                  _c("span", {
                                    staticClass: "path1 letterSpacing0",
                                  }),
                                  _c("span", {
                                    staticClass: "path2",
                                    staticStyle: { "margin-left": "-1px" },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "v-list-item",
                { staticClass: "mb-0" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "remove-btn-text-transform",
                      staticStyle: {
                        "padding-left": "10px",
                        "padding-right": "10px",
                      },
                      attrs: { text: "" },
                      on: { click: _vm.addNewProfile },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-4",
                          attrs: { color: "primary", size: "22" },
                        },
                        [_vm._v("fas fa-plus-circle ")]
                      ),
                      _vm._v(" Copy from "),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-row",
                        { staticClass: "ma-0" },
                        [
                          _c("v-spacer"),
                          _c("v-select", {
                            staticClass: "mt-0",
                            staticStyle: { "max-width": "134px" },
                            attrs: {
                              items: _vm.clonableProfiles,
                              dense: "",
                              value: "",
                              "hide-details": "",
                              "x-small": "",
                              "return-object": "",
                              "menu-props": { bottom: true, offsetY: true },
                              "item-text": "configuration.device",
                              "item-value": "id",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "py-2 char-lim-tabs page-rows-selection",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "py-2",
                                            staticStyle: {
                                              "font-size": "0.8125rem",
                                              "font-weight": "500",
                                              "line-height": "1rem",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.username
                                                    ? item.configuration.device
                                                    : "Default"
                                                ) +
                                                " "
                                            ),
                                            _vm.isAdmin && item.username
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pt-2 grey--text",
                                                    staticStyle: {
                                                      display: "inline",
                                                      "font-size": "12px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " (" +
                                                        _vm._s(item.username) +
                                                        ") "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "selection",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "page-rows-selection" },
                                      [
                                        item.username
                                          ? _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.configuration.device
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  "v-row",
                                                  { staticClass: "mx-0" },
                                                  [_vm._v(" Default ")]
                                                ),
                                              ],
                                              1
                                            ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.copyFrom,
                              callback: function ($$v) {
                                _vm.copyFrom = $$v
                              },
                              expression: "copyFrom",
                            },
                          }),
                          _vm.$vuetify.breakpoint.width > 390
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    "max-width": "300",
                                    bottom: "",
                                    "content-class": "text-center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _vm.$vuetify.breakpoint.width > 390
                                              ? _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass: "pt-1 mx-3",
                                                      attrs: { small: "" },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "far fa-question-circle "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3207355332
                                  ),
                                },
                                [
                                  _c("span", { staticClass: "text-center" }, [
                                    _vm._v(
                                      " Create a new profile from an existing one. All settings will be copied. "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c("v-checkbox", {
                staticClass: "general-checkbox statusText my-0 py-3 pl-4",
                attrs: {
                  "off-icon": "far fa-square",
                  "on-icon": "fas fa-check-square",
                  label: "Don't ask again",
                  "hide-details": "",
                  dense: "",
                },
                model: {
                  value: _vm.dontAskAgain,
                  callback: function ($$v) {
                    _vm.dontAskAgain = $$v
                  },
                  expression: "dontAskAgain",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }